import CoreSkeleton, { type SkeletonProps as CoreSkeletonProps } from '@ovpn/ui/skeleton';

import { boxed } from '@sso/shared/hocs';

type SkeletonProps = Omit<CoreSkeletonProps, 'shape'> & {
    shape?: CoreSkeletonProps['shape'];
};

function Skeleton({ shape = 'rect', ...props }: SkeletonProps) {
    return <CoreSkeleton shape={shape} {...props} />;
}

export default boxed(Skeleton);
